module.exports = __webpack_public_path__ + "media/site_templates/www.guttercleaning.biz/images/testimonials-fd5c14e430262124ac210c33a8c5853e.jpg";